import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { STATUS_KEYS } from 'scaleflow/models/initiative-update';

export default class InitiativesProgressPanelIndexComponent extends Component {
  @service initiativeSlideover;
  @service store;
  @service router;
  @service currentUser;
  status_keys = STATUS_KEYS;

  @tracked progress = this.store.createRecord('initiative-update');

  get isOpen() {
    return this.initiativeSlideover.progressPanelIsOpen;
  }

  get initiative() {
    return this.initiativeSlideover.initiative;
  }

  @action
  closeSlideover() {
    this.initiativeSlideover.closeProgressPanel();
  }

  get sortedUpdates() {
    return this.initiative?.orderedUpdates;
  }
}
